// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3uWW6","headLogo":"Logo_headLogo__TjtUy"};